import { apiHelper } from "./core"
import moment from "moment"

const userServiceBaseUrl = process.env.REACT_APP_USER_MANAGEMENT_BASE_URL
const clinicalServiceBaseUrl =
  process.env.REACT_APP_CLINICAL_MANAGEMENT_BASE_URL
const resourceServiceBaseUrl =
  process.env.REACT_APP_RESOURCE_MANAGEMENT_BASE_URL
const masterServiceBaseUrl = process.env.REACT_APP_MASTER_BASE_URL

//Billing general Table
const getAllInvoices = (Id: any, date: any, userRole: any): Promise<any> => {
  const url =
    userRole === "INSURANCE"
      ? `invoices/center?date=${date}&sort=createdAt&order=DESC`
      : `invoices/center?centerId=${Id}&date=${date}&sort=createdAt&order=DESC`
  return apiHelper
    .get(`${resourceServiceBaseUrl}/${url}`)
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//global Search for billing
const getInvoiceSearchResult = (
  searchValue: any,
  centerId: any
): Promise<any> => {
  return apiHelper
    .get(
      `${resourceServiceBaseUrl}/invoices/center?centerId=${centerId}&searchText=${searchValue}`
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//get details invoice of a particular id
const getInvoiceByPatientId = (Id: any, appointmentType?: String, pageSize?: Number, pageNumber?: Number): Promise<any> => {
  let url = `${resourceServiceBaseUrl}/invoices?patientId=${Id}&sortBy=billedDate`;

  if (appointmentType) {
    url += `&appointmentType=${appointmentType}`
  }
  if (pageSize !== undefined && pageNumber !== undefined) {
    url += `&pageSize=${pageSize}&pageNumber=${pageNumber}`
  }

  return apiHelper
    .get(url)
    .then((res: any) => {
      return res?.data?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//get details invoice of a particular id
const getInvoiceDetailsByPatientId = (Id: any): Promise<any> => {
  return apiHelper
    .get(
      `${resourceServiceBaseUrl}/invoices/patient?patientId=${Id}&sortBy=billedDate`
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

const getPrintInvoiceDetailedById = (
  Id: any,
  detailedView?: any
): Promise<any> => {
  return apiHelper
    .get(
      `${resourceServiceBaseUrl}/invoices/patient/${Id}${detailedView ? `?getDetailedView=${detailedView}` : ""
      }`
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

const getPatientLedgerDetails = (
  Id: any,
  startDate: any,
  endDate: any,
  isDownload: any = false
): Promise<any> => {
  return apiHelper
    .get(
      `${resourceServiceBaseUrl}/invoices/patient-ledger?patientId=${Id}&${moment(startDate).format("YYYY-MM-DD") !== "Invalid date"
        ? `fromDate=${moment(startDate).format("YYYY-MM-DD")}&`
        : ""
      }${moment(endDate).format("YYYY-MM-DD") !== "Invalid date"
        ? `toDate=${moment(endDate).format("YYYY-MM-DD")}&`
        : ""
      }${isDownload ? `isDownload=${isDownload}&` : ""}`
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//get details invoice of a particular id
const getAllPatientInfoByPatientId = (Id: any): Promise<any> => {
  return apiHelper
    .get(`${userServiceBaseUrl}/patients/${Id}`)
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//update refund information
const updateRefundPatient = (values: any, Id: any): Promise<any> => {
  return apiHelper
    .put(`${userServiceBaseUrl}/patients/${Id}/refund`, values, Id)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

//get details by appointment id
const getInvoiceDetailsById = (Id: any): Promise<any> => {
  return apiHelper
    .get(`${resourceServiceBaseUrl}/invoices/${Id}`)
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//get Details of invoice History
const getInvoiceHistory = (Id: any): Promise<any> => {
  return apiHelper
    .get(`${resourceServiceBaseUrl}/invoices/${Id}/history`)
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//get patient Refund History
const getRefundHistory = (Id: any): Promise<any> => {
  return apiHelper
    .get(`${userServiceBaseUrl}/patients/${Id}/refund`)
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

// advance payment
const saveAdvancePayment = (values: any, Id: any): Promise<any> => {
  return apiHelper
    .put(`${resourceServiceBaseUrl}/invoices/${Id}/advance-payment`, values, Id)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

//get all past billing details
const getAllBillingDetails = (): Promise<any> => {
  return apiHelper
    .get(`${resourceServiceBaseUrl}/invoices`)
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//get services dropdown
const getAllServices = (centerId: any): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/services?centerId=${centerId}`)
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

const getLineItemCharges = (invoiceId: any, serviceId: any): Promise<any> => {
  return apiHelper
    .get(
      `${resourceServiceBaseUrl}/invoices/line-item-charges?invoiceId=${invoiceId}&serviceId=${serviceId}`
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//Save and proceed invoice
const saveAndProceedInvoice = (values: any, Id: any): Promise<any> => {
  return apiHelper
    .put(`${resourceServiceBaseUrl}/invoices/${Id}`, values)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

//save final Invoice
const saveFinalInvoice = (values: any, Id: any): Promise<any> => {
  return apiHelper
    .put(`${resourceServiceBaseUrl}/invoices/${Id}/payment`, values)
    .then((res) => {
      //console.log("hello")
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

//const get all categories
const getAllCategories = (): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/category/all-categories`)
    .then((res: any) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

//get All Payemnt Modes
const getAllPaymentModes = (): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/moc-master`)
    .then((res: any) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

//Get all SubCategories
const getAllSubCategoriesInfo = (): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/category/sub-categories`)
    .then((res: any) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

//save subcategory
const saveSubCategory = (values: any): Promise<any> => {
  return apiHelper
    .post(`${masterServiceBaseUrl}/category`, values)
    .then((res) => {
      //console.log("hello")
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

//const get Category for Insurance

const getSubCategoryByCategory = (category: any): Promise<any> => {
  return apiHelper
    .get(
      `${masterServiceBaseUrl}/category/sub-categories?companyCategoryType=${category}`
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//Get Print Details
const getPrintDetails = (invoiceId: any): Promise<any> => {
  return apiHelper
    .get(`${resourceServiceBaseUrl}/invoices/print/${invoiceId}`)
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//update category details in billing
const categoryUpdate = (categoryId: any, Id: any): Promise<any> => {
  return apiHelper
    .put(
      `${resourceServiceBaseUrl}/invoices/${Id}/category?categoryId=${categoryId}`
    )
    .then((res) => {
      console.log("hello")
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

export {
  getAllBillingDetails,
  getInvoiceByPatientId,
  getAllServices,
  getLineItemCharges,
  saveAndProceedInvoice,
  saveAdvancePayment,
  getAllInvoices,
  getInvoiceDetailsById,
  getPatientLedgerDetails,
  saveFinalInvoice,
  getAllCategories,
  getSubCategoryByCategory,
  categoryUpdate,
  getAllPatientInfoByPatientId,
  updateRefundPatient,
  getPrintDetails,
  getInvoiceSearchResult,
  saveSubCategory,
  getAllSubCategoriesInfo,
  getAllPaymentModes,
  getInvoiceHistory,
  getRefundHistory,
  getInvoiceDetailsByPatientId,
  getPrintInvoiceDetailedById,
}
